import { cn } from './lib/utils';

export type PhoneInputProps = {
  name: string;
  countryCodes: string[];
  invalid: boolean;
  defaultSelected?: string;
  placeholder?: string;
  className?: string;
};

export default function PhoneInput({
  name,
  countryCodes,
  invalid,
  defaultSelected,
  className,
  ...props
}: PhoneInputProps) {
  return (
    <div className="m-y-1 rounded-[calc(theme(borderRadius.lg)-1px)] shadow-sm" data-slot={'control'}>
      <div
        className={cn(
          // Base
          'inset-px flex rounded-lg border bg-white',
          // Focus
          'has-[input:focus-within]:border-bright-blue has-[input:focus-within]:outline-bright-blue has-[input:focus-within]:ring-bright-blue has-[input:focus-within]:border has-[input:focus-within]:outline has-[input:focus-within]:outline-0 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:ring-2',
          // Border
          invalid
            ? 'border-red-500 hover:border-red-500 dark:border-red-500 hover:dark:border-red-500'
            : // Invalid
              'border-gray-12/15 hover:border-gray-12/25 dark:border-white/15 dark:hover:border-white/25',
        )}
      >
        <div className="text-gray mr-2 grid shrink-0 grid-cols-1 focus-within:relative">
          <select
            id="countryCode"
            name={name}
            defaultValue={defaultSelected || undefined}
            autoComplete="tel-country-code"
            aria-label="Country Code"
            className="focus:border-bright-blue col-start-1 row-start-1 w-full appearance-none rounded-md border border-transparent py-1.5 pl-3 pr-7 text-base focus:border focus:outline-none focus:ring-2 sm:text-sm/6"
          >
            {countryCodes.map((code) => {
              return <option key={code}>{code}</option>;
            })}
          </select>
        </div>
        <input
          id="phone-number"
          name={name}
          autoComplete="tel-national"
          type="tel"
          className={cn(
            className,
            'border-0 focus:outline-none focus:ring-0',
            // Basic layout
            'relative block w-full appearance-none rounded-lg px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)]',
            // Typography
            'text-gray-12 placeholder:text-gray-6 text-base/6 sm:text-sm/6 dark:text-white',
            // 'placeholder:text-gray-4 text-gray-9 block min-w-0 grow py-1.5 pl-1 pr-3 text-base focus:outline focus:outline-0 sm:text-sm/6',
          )}
          {...props}
        />
      </div>
    </div>
  );
}
